export default __webpack_public_path__ + "static/media/eye-close.4961eeb1.svg";